import React, { useEffect } from "react";
import Mobile from "../../Common/Mobile2";
import Question from "./Components/Question";
import Search from "./Components/Search";
import { useQuestions } from "./Hooks";

const Index = ({ isApp }) => {
  const { getData, loading, data, search, setSearch } = useQuestions();
  useEffect(() => {
    getData();
  }, []);

  // if (loading) {
  //   <section>loading</section>;
  // }

  return (
    <section className="background-gray pb-3" id="faq-page">

      <Search
        loading={loading}
        data={data.categories}
        setSearch={setSearch}
        search={search}
        isApp={isApp}
      />


      <Question isApp={isApp} loading={loading} data={data.questions} search={search} />

      {!isApp && <div className="container">
        <div className="row">
          <div className="col-12">
            <Mobile />
          </div>
        </div>
      </div>}
    </section>
  );
};

export default Index;
